<template>
  <div />
</template>

<script>

import * as types from '@/store/types';
import { mapMutations } from 'vuex';
import { Auth } from 'aws-amplify';
import { noop } from 'lodash';

export default {
  name: 'ShareRouter',
  data() {
    return {
    };
  },
  methods: {
    ...mapMutations([
      types.SET_GLOBAL_MESSAGE,
    ]),
  },
  async created() {
    const {
      redirectUrl,
      registered,
      r,
    } = this.$route.query;

    const authenticatedUser = await Auth.currentAuthenticatedUser().catch(() => noop());
    const isUserRegistered = registered ?? r;
    if (authenticatedUser) {
      this.$router.push(`${redirectUrl}`);
    } else if (isUserRegistered === 'false') {
      this.SET_GLOBAL_MESSAGE({
        message: 'Please sign up first before redirecting to your share',
        type: 'warning',
      });
      this.$router.push(`/register?redirect=${redirectUrl}`);
    } else {
      this.$router.push(`${redirectUrl}`);
    }
  },
};
</script>
